import * as React from 'react'

interface PublishIconNewProps extends React.SVGProps<SVGSVGElement> {
  size?: number
  color?: string
}

export const PublishIconNew: React.FC<PublishIconNewProps> = ({
  size = 32,
  color = '#FFFFFF',
  ...props
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" {...props}>
      <path
        d="M8 14.5454V18.9091C8 21.3191 9.95368 23.2728 12.3637 23.2728H19.6364C22.0464 23.2728 24.0001 21.3191 24.0001 18.9091V14.5454"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9999 8.72723V17.4546M15.9999 8.72723L13.0908 11.5041M15.9999 8.72723L18.909 11.5041"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
